import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SourceMaintenanceApiService } from '../../../../../../modules/api/source-maintenance-api.service';

@Component({
    templateUrl: './add-source-modal.template.html'
})
export class AddSourceModalComponent {

    loading = false;

    form: UntypedFormGroup = new UntypedFormGroup({
        sourceName: new UntypedFormControl('',
            [
                (control: AbstractControl): { [key: string]: any } | null =>
                    control.value.localeCompare('ALL SOURCES', undefined, { sensitivity: 'base' }) === 0 ?
                        { 'notEqualsAllSources': { value: control.value } } : null,
                Validators.required
            ]),
        code: new UntypedFormControl('', Validators.maxLength(3)),
        contactEmail: new UntypedFormControl('', Validators.email),
        contactEmail2: new UntypedFormControl('', Validators.email),
        contactEmail3: new UntypedFormControl('', Validators.email),
        contactEmail4: new UntypedFormControl('', Validators.email),
        contactEmail5: new UntypedFormControl('', Validators.email),
        userSourceContactEmail1: new UntypedFormControl('', Validators.email),
        userSourceContactEmail2: new UntypedFormControl('', Validators.email),
        userSourceContactEmail3: new UntypedFormControl('', Validators.email),
        userSourceContactEmail4: new UntypedFormControl('', Validators.email),
        userSourceContactEmail5: new UntypedFormControl('', Validators.email),
        userSourceContactEmail6: new UntypedFormControl('', Validators.email),
        userSourceContactEmail7: new UntypedFormControl('', Validators.email),
        inside: new UntypedFormControl(false),
        outside: new UntypedFormControl(false),
        cadence: new UntypedFormControl(false),
        designSource: new UntypedFormControl(false),
        constSource: new UntypedFormControl(false),
        firstUserSource: new UntypedFormControl(false),
        userSource: new UntypedFormControl(false),
        active: new UntypedFormControl(true),
    });

    constructor(
        public readonly dialogRef: MatDialogRef<AddSourceModalComponent>,
        private readonly sourceMaintenanceApiService: SourceMaintenanceApiService,
        private readonly toastr: ToastrService
    ) { }

    onSaveClick() {
        this.loading = true;

        this.sourceMaintenanceApiService.createSource(this.form.value)
            .pipe(finalize(() => this.loading = false))
            .subscribe(
                (response: any) => {
                    this.toastr.success(`Create new source with name ${response.sourceName}`);
                    this.dialogRef.close(response);
                }
            );
    }

    close() {
        this.dialogRef.close();
    }
}
